import { loadablePage } from 'src/utils/loadable';

export default loadablePage(() => import('./PaymentFlowPage.component'));
